
<template>
    <div class="center">
      <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            ¿Esta seguro de eliminar el registro?
          </h4>
        </template>


        <div class="con-form">
            El registro se eliminará permanentemente.
        </div>

        <template #footer>
          <div class="footer-dialog">
              <vs-row>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        danger
                        flat
                        @click="active = false"
                    >
                        Cancelar
                    </vs-button>
                  </vs-col>
                  <vs-col sm="6" lg="6">
                    <vs-button
                        success
                        @click="getEliminarMateria()"
                        class="ml-auto"
                    >
                        Aceptar
                    </vs-button>
                  </vs-col>
              </vs-row>
          </div>
        </template>
      </vs-dialog>
    </div>
</template>
<script>
import academico from '../../../../../api/requests/academico.js'
export default {
    props:[
        'value',
        'row'
    ],
    data:() => ({
    active: false,
    }),
    methods:{
      async getEliminarMateria(){
        const loading = this.$vs.loading()
        try{
          let params = {
            'materia_promediable_id': this.row.id
            
          }
          const { data: response } = await academico.getEliminarMateria(params)
          this.active = false
          this.$emit('refreshTable')
          loading.close()
          this.$vs.notification({
              progress: 'auto',
              duration: 5000,
              color: 'success',
              title: 'Se ha eliminado éxitosamente la materia',
          })
        }catch{
            loading.close()
            this.active = false 
            this.$vs.notification({
                progress: 'auto',
                duration: 8000,
                color: 'danger',
                title: 'Hubo un error',
                text: 'Favor de contactar al administrador'
            })

        }
      }
    },
    watch:{
        
        value (val) {
            this.active = val
        },       
        async active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
  </script>